export default {
  noSupport: 'current environment dose not support share'
}

